module.exports = __webpack_public_path__ + "da880ecf43392db51657320cc0752868.pdf";